import { render, staticRenderFns } from "./SensorDetail.vue?vue&type=template&id=1fff6936&"
import script from "./SensorDetail.vue?vue&type=script&lang=js&"
export * from "./SensorDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports